export default {
  systemSybol: '---ipark_saas',
  set (key, value) {
    sessionStorage.setItem(key + this.systemSybol, JSON.stringify(value))
  },
  get (key) {
    const val = sessionStorage.getItem(key + this.systemSybol)
    if (val !== undefined) {
      return JSON.parse(val)
    }
    return null
  },
  remove (key) {
    sessionStorage.removeItem(key + this.systemSybol)
  },
  clear () {
    const storageLength = sessionStorage.length
    let deleteIndex = 0
    for (let i = 0; i < storageLength; i += 1) {
      if (sessionStorage.key(deleteIndex) &&
        sessionStorage.key(deleteIndex).indexOf(this.systemSybol) !== -1) {
        sessionStorage.removeItem(sessionStorage.key(deleteIndex))
      } else {
        deleteIndex += 1
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/area-base/utils/session.js